import React from 'react';
import AMCConstants from './AMCConstants';
import ZLog from './zlog';
import ZProps from './zprops';
import ZNetwork from './znetwork';
import ZAPI from './zapi';
import ZUtil from './zutil';
import ZToolTip from './ztooltip';
import AMCRouter, { ROUTER } from './AMCRouter';
import AMC from './AMC';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import PleaseStandBy from "./PleaseStandBy";

import './style.css';

//import createHistory from 'history/createBrowserHistory'


export var WS = null;
export var APP = null;

export default class App extends React.Component {
	constructor(props) {
		super(props);
		console.log(`Client version: ${AMCConstants.VERSION}.${AMCConstants.SUBVERSION}`);
		WS = this;
		APP = this;
		ZProps.set("path", decodeURIComponent(window.location.href));
		this.state = { ninja: ZUtil.getCandy("ninja") };
		ZProps.set("ninja", this.state.ninja);
		this.accelerator_id = 0;
		this.accelerators = [];
		ZLog.setLevel(parseInt(ZUtil.getCandy("loglevel"), 10));
		APP.registerAcceleratorKey("ctrlKey", "m", () => { 
			if (ZLog.getLevel() === 5) {
				ZUtil.setCandy("loglevel", 1);
				ZLog.setLevel(1);
			} else {
				ZUtil.setCandy("loglevel", 5);
				ZLog.setLevel(5);
			}
		});
	}
	componentDidMount() {
		//ZProps.set("user", { uri: "guest000", plan: "guest" });
		this.forceUpdate();
		this.listener = ZProps.addListener("theme", (name, value, oldvalue) => {
			this.forceUpdate();
		});
		ZNetwork.init((err) => {
			if (err) {
				this.setState({ error: "Waiting for server" });
				ZLog.error("Server initialization error", err);
				setTimeout(this.componentDidMount.bind(this), 10000);
				return;
			}
			this.setState({ error: null });
			var user = ZProps.get("user");
			AMC.init();
			ZToolTip.init();
			ZAPI.getVersion( (err, version) => {
				console.log("API version: " + version);
			});
			this._waitForTracking();
			this._initCloudinary();
			// not for single page app this._initEditedPageExitWarning();
			if (user.plan === "guest" && (ZUtil.getCandy("beta") || 0) < Date.now() - 30*24*60*60*1000) {
				// beta
				ZProps.set("beta", true);
				// ROUTER.pushRoute("/beta");
			}
			AMCRouter.init();
			if (ZProps.get("beta") && !window.location.pathname.startsWith("/-/")) {
				ROUTER.setRoute("/");
			}
		});
	}
	_initEditedPageExitWarning() {
		window.onload = function() {
			window.addEventListener("beforeunload", function (e) {
				if (ZProps.get("page_has_changed")) {
        				let msg = 'It looks like you have been editing something. '
                                		+ 'If you leave before saving, your changes will be lost.';
        				(e || window.event).returnValue = msg; //Gecko + IE
					return msg; //Gecko + Webkit, Safari, Chrome etc.
				}
			});
		};
	}
	_initCloudinary() {
		if (window.cloudinary) {
			window.cloudinary.setCloudName("dfv2fdlqt");
		} else {
			setTimeout(this._initCloudinary, 1000);
		}
	}
	_waitForTracking() {
		if (!ZProps.get(AMCConstants.TRACKINGS_LOADED)) {
			return setTimeout(this._waitForTracking.bind(this), 20);
		}
		this.setState({ loaded: true });
	}
	setTitle(title) {
		document.title = title ? "Automatic.ai - " + title : "Automatic.ai - AI for the rest of us";
	}
	_setPage(element) {
		this.details = { title: element.getAttribute("data-title"), name: element.getAttribute("data-name"), details: element.getAttribute("data-details") }
		this.setTitle(this.details.title);
	}
	getDetails() {
		return this.details;
	}
	enableModalBackground(callback) {
		this.modalbackgroundhandler = callback;
		document.getElementById("modalbackground").style.display = "block";
	}
	disableModalBackground() {
		this.modalbackgroundhandler = null;
		document.getElementById("modalbackground").style.display = "none";
	}
	onModalBackgroundClick() {
		this.modalbackgroundhandler();
		this.disableModalBackground();
	}
	areYouSure(yes_function, msg="Are you sure about that?") {
		this.showPopup(<div className="ACAreYouSurePopup CENTEREDPART MODAL"><h1 className="ACAreYouSureMsg">{msg}</h1><button className="ACAreYouSureButtonYes ACButton" onClick={this.theyAreSure.bind(this, true)}>yep</button><button className="ACAreYouSureButtonNo ACButton" onClick={this.theyAreSure.bind(this, false)}>nope</button></div>);
		this.setState({areyousure: yes_function});
	}
	theyAreSure(flag, event) {
		if (flag) {
			let options = this.state.areyousure(event);
			if (options && options.popup) {
				// Another popup follows areyousure... do not close it
				return this.setState({areyousure: null});
			}
		}
		this.setState({areyousure: null});
		this.closePopups();
	}
	setWorking(flag) {
		this.setState({ working: flag });
	}
	setError(errormsg) {
		ZLog.error(errormsg);
		this.setState({ errormsg: errormsg });
	}
	clearError() {
		this.setState({ errormsg: null });
	}
	setBanner(bannermsg) {
		this.setState({ bannermsg: bannermsg });
	}
	clearBanner() {
		this.setState({ bannermsg: null });
	}
	show(component) {
		// TESTT this.payload = component;
		this.titled = false;
		this.setState({show: component, popup: false});
	}
	showPopup(component, popup_modal_background) {
		this.setState({popup: component, popup_modal_background: popup_modal_background});
	}
	showMenu(component) {
		this.setState({menu: component});
	}
	isPopped() {
		return !!this.state.popup;
	}
	closePopups = (event) => {
		if (!event || (event.target.nodeName !== "BUTTON" && (event.target.className || "").includes("MODAL"))) {
			this.showPopup(null);
			this.showMenu(null);
			if (event) {
				event.preventDefault();
			}
		}
	}
	registerAcceleratorKey(state, key, fn) {
		this.accelerators.push({ state: state, key: key, fn: fn, id: ++this.accelerator_id });
		return this.accelerator_id;
	}
	unregisterAcceleratorKeys(list) {
		list.forEach( id => {
			let index = this.accelerators.findIndex(a => a.id === id);
			if (index !== -1) {
				this.accelerators.splice(index, 1);
			}
		});
	}
	onKeyDown = (event) => {
		ZLog.debug("APP.processGlobalKeyInputDown");
		if (event.target && (event.target.nodeName.toLowerCase() === 'input' || event.target.nodeName.toLowerCase() === 'textarea')) {
			ZLog.debug("APP.processGlobalKeyInputDown exiting: text input has focus");
			return;
		}
		if (event.repeat) {
			return;
		}
		let key = event.key;
		ZLog.debug("APP.processGlobalKeyInputDown key='" + key + "'");
		for (let i = this.accelerators.length - 1; i >= 0; --i) {
			let a = this.accelerators[i];
			if ((!a.state || event[a.state]) && key === a.key) {
				ZLog.debug("APP.processGlobalKeyInputDown calling fn");
				return a.fn();
			}
		}
	}
	toggleNinja = (flag) => {
		let to_open = flag !== false && (flag === true || !this.state.ninja);
		let ninja = to_open ? "ninja" : null;
		this.setState({ ninja: ninja });
		ZProps.set("ninja", ninja);
		to_open ? ZUtil.setCandy("ninja", ninja) : ZUtil.deleteCandy("ninja");
	}
	appoveCookies = () => {
		ZUtil.setCandy("cookies-approved", "yep");
		this.forceUpdate();
	}
	showBatteryLowMsg = () => {
		this.setState({ batterylow: true });
	}
	defeatBatteryLowMsg = () => {
		ZUtil.setCandy("hide-battery-low-msg", Date.now());
		this.forceUpdate();
	}
	render() {
		let { show, popup, popup_modal_background, menu, working, errormsg, bannermsg, error, loaded, batterylow } = this.state;
		let payload = show;
		if (error) { //  || !loaded) {
			return <PleaseStandBy />;
		}
		let darktheme = false;
		let apppage_style = {};
		let ERROR_MSG_HEIGHT = 2;
		let apppage_top = ((errormsg || bannermsg) ? ERROR_MSG_HEIGHT : 0) + "em";
		if (payload) {
			// Get rid of background logo
			if (ZProps.get("path") === "/zoo") {
				let theme = ZProps.get("theme");
				if (theme) { 
					darktheme = theme.dark;
					apppage_style = { background: theme.background, height: "100%", overflow: "hidden" };
				}
			} else {
				apppage_style = { background: "transparent" }
				ZProps.set("darktheme", false);
			}
		} else {
			apppage_style = { background: "url(" + AMCConstants.LOGO + ") center center no-repeat", backgroundSize: "33%" };
		}
		apppage_style.top = apppage_top;
			// double invocations of rockstar contructor.
			// <React.StrictMode> 
			// </React.StrictMode>
		let cookiemsg = null;
		if (!ZUtil.getCandy("cookies-approved") && !ZProps.get("beta") && loaded) {
			cookiemsg = <div>We use cookies for security and to offer you a better user experience.<a href="https://google.com">decline</a> <a onClick={e => this.appoveCookies()}>allow cookies</a> <a onClick={e => ROUTER.pushRoute("/-/privacy")}>privacy policy</a></div>;
		}
		let batterylowmsg = null
		if ((batterylow) && (Date.now() - parseInt(ZUtil.getCandy("hide-battery-low-msg"), 10) || 0) > 15*1000) { // 12*60*60*1000) {
			let plan = (ZProps.get("usergroup") || {}).plan;
			batterylowmsg = <div>{`You've Reached Your ${plan === "member" || plan === "guest" ? "Daily" : "Monthly"} Limit - Please upgrade your account or buy a battery pack to keep using Automatic or you can come back in 24 hours when your daily limit resets.`} <span onClick={this.defeatBatteryLowMsg}>NO THANKS</span> <span onClick={ e=> ROUTER.pushRoute("/-/pricing") }>UPGRADE</span></div>
		}
		ZLog.debug("beta=" + ZProps.get("beta"));
		return (
			<div className="App" onKeyDown={this.onKeyDown} tabIndex="0" >
				{ errormsg ? <div className="APPErrorBanner" onClick={this.clearError.bind(this)}>{errormsg}<span className="APPErrorBannerCloseButton"><FontAwesomeIcon icon={faTimes} /></span></div> : '' }
				{ bannermsg ? <div className="APPSuccessBanner" onClick={this.clearBanner.bind(this)}>{bannermsg}<span className="APPErrorBannerCloseButton"><FontAwesomeIcon icon={faTimes} /></span></div> : '' }
				{ cookiemsg ? <div className="APPCookieBanner">{cookiemsg}</div> : '' }
				{ batterylowmsg ? <div className="APPBatteryLowBanner">{batterylowmsg}</div> : '' }
				<div id="modalbackground" className="WModalBackground MODAL" style={{zIndex:  AMCConstants.MODAL_DIALOG_ZINDEX - 1}} onClick={this.onModalBackgroundClick.bind(this)}></div>

				<div id="apppage" className={"AppPage Clear" + (ZProps.get("beta") ? " BetaGateway" : "") + (darktheme ? " AppPageDarkTheme" : "")} key={ZUtil.getCandy("username")} style={apppage_style}>
					{payload}
				</div>
				{ popup ? 
					<div className="ACModalBackground MODAL" style={ popup_modal_background ? {background: popup_modal_background} : {}} onClick={this.closePopups} onContextMenu={this.closePopups}>
						{popup}
					</div>
				: '' }
				{ menu ? 
					<div className="ACPlainModalBackground MODAL" onClick={this.closePopups}>
						{menu}
					</div>
				: '' }
				{ working ? <div className="CENTERED_PART"><img alt="waiting" src="/images/wait.gif" /></div> : '' }
			</div>
		)

	}
	componentDidUpdate() {
		if (!this.titled) {
			let page = document.getElementsByClassName("PAGE")[0];
			if (page) {
				this._setPage(page);
				this.titled = true;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/App.js